const produto = angular.module('produto', [])

produto.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'cliente.produto',
            url: '/produto/:idProduto',
            params: { showGlobalLoading: { dynamic: true, value: true } },
            component: 'produto.produtoComponent'
        },
        {
            name: 'cliente.produtoModulo',
            url: '/produto/:idProduto/modulo/:idModulo',
            params: { showMenu:false, showGlobalLoading: { dynamic: true, value: true } },
            component: 'produto.moduloComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);